import { Navigate } from "react-router-dom"
import { jwtDecode } from 'jwt-decode'

/**
 * Comprueba si el usuario está logeado
 * @returns Redirecciona al login si no está logeado y si lo está renderiza la vista pedida
 */
const DepartmentPrivateRouter = ({children}) => {
    const token = localStorage.getItem('jwt')

    if (!token || token === 'undefined') {
        return <Navigate to="/"/>
    }

    let role = ''

    try {
        const token_decode = jwtDecode(token)
        role = String(token_decode.rol || '').toLowerCase()
    } catch (error) {
        return <Navigate to="/"/>
    }

    if(role === 'department' || role === 'commercial'){
        return children
    }

    return <Navigate to="/"/>
}

export default DepartmentPrivateRouter
